$(document).ready(function(){

	// -- init Masonry
	var masonrySettings = {
		itemSelector: '.grid--item',
		columnWidth: '.grid--sizer',
		percentPosition: true,
		gutter: 30,
	};
	var $grid = $('.grid').masonry(masonrySettings);
	// $grid.imagesLoaded().progress( function() {
	//   $grid.masonry('layout');
	// });

	// $('button.hamburger').on('click', function(){
	// 	$('.grid').masonry(masonrySettings);
	//   // $grid.masonry('layout');
	// });

});